import { createFileRoute } from "@tanstack/react-router";
import { ServiceLayout } from "@/components/ServiceLayout";
import { img } from "@/lib/images";
import { canonicalLinks, routeMeta } from "@/lib/seo";

export const Route = createFileRoute("/services/accounting")({
  head: () => ({
    meta: [
      ...routeMeta("/services/accounting"),
      { title: "Winter Garden Accounting Services | CCOB & Company" },
      { name: "description", content: "Bookkeeping, payroll, financial analysis, and business reporting from a trusted Winter Garden CPA firm." },
      { property: "og:title", content: "Accounting Services — CCOB And Company PA" },
      { property: "og:description", content: "Bookkeeping, payroll, financial analysis & reporting." },
    ],
    links: canonicalLinks("/services/accounting"),
  }),
  component: () => (
    <ServiceLayout
      eyebrow="Accounting"
      title="Accounting Services That Power Confident Decisions"
      subtitle="From clean books to clear reports, we keep your numbers accurate and actionable."
      hero={img.heroAccounting}
      image={img.accounting}
      intro="Whether you're a sole proprietor or a growing business, our accounting services are designed to give you a real-time understanding of your financial health — without the spreadsheets nightmare."
      items={[
        { title: "Bookkeeping", desc: "Accurate, monthly bookkeeping that keeps your records audit-ready and stress-free." },
        { title: "Financial Analysis", desc: "Insightful analysis that translates numbers into strategy and growth opportunities." },
        { title: "Payroll", desc: "Reliable payroll processing, tax filings, and reporting for businesses of every size." },
        { title: "Business Financial Reporting", desc: "Monthly, quarterly, and annual financial statements you can actually use." },
      ]}
    />
  ),
});
